
(function() {
  'use strict';

  const RecentlyViewedTracker = {
    storageKey: 'recently-viewed-products',
    maxProducts: 12, // Maximum number of products to store
    
    init: function() {
      // Only track on product pages
      if (this.isProductPage()) {
        this.trackCurrentProduct();
      }
    },
    
    isProductPage: function() {
      return document.body.classList.contains('template-product') || 
             window.location.pathname.includes('/products/');
    },
    
    trackCurrentProduct: function() {
      // Wait for the page to fully load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.captureProductData();
        });
      } else {
        this.captureProductData();
      }
    },
    
    captureProductData: function() {
      try {
        const productData = this.getProductData();
        if (productData) {
          this.saveProduct(productData);
        }
      } catch (error) {
        console.warn('Recently Viewed Tracker: Error capturing product data', error);
      }
    },
    
    getProductData: function() {
      // Try to get product data from Shopify's product object first
      if (typeof product !== 'undefined' && product) {
        return {
          id: product.id,
          handle: product.handle,
          title: product.title,
          url: window.location.pathname,
          image: product.featured_image || product.images[0] || '',
          price: this.formatPrice(product.price),
          timestamp: Date.now()
        };
      }
      
      // Fallback: Extract data from DOM elements
      return this.getProductDataFromDOM();
    },
    
    getProductDataFromDOM: function() {
      const productTitle = this.getProductTitle();
      const productImage = this.getProductImage();
      const productPrice = this.getProductPrice();
      const productHandle = this.getProductHandle();
      
      if (!productTitle || !productImage) {
        return null;
      }
      
      return {
        id: Date.now(), // Fallback ID
        handle: productHandle,
        title: productTitle,
        url: window.location.pathname,
        image: productImage,
        price: productPrice || '',
        timestamp: Date.now()
      };
    },
    
    getProductTitle: function() {
      const selectors = [
        'h1.product-title',
        'h1.product__title',
        '.product-single__title',
        '.product__title',
        'h1[class*="product"]',
        'h1'
      ];
      
      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element && element.textContent.trim()) {
          return element.textContent.trim();
        }
      }
      
      return document.title.split(' |')[0] || '';
    },
    
    getProductImage: function() {
      const selectors = [
        '.product-featured-image img',
        '.product__media img',
        '.product-single__photo img',
        '.product-image img',
        '.product img',
        'img[class*="product"]'
      ];
      
      for (const selector of selectors) {
        const img = document.querySelector(selector);
        if (img && img.src) {
          // Get a medium-sized image
          return img.src.replace(/_(large|grande|master|original)/g, '_medium');
        }
      }
      
      return '';
    },
    
    getProductPrice: function() {
      const selectors = [
        '.product-price .price',
        '.product__price .price',
        '.price',
        '[class*="price"]'
      ];
      
      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element && element.textContent.trim()) {
          return element.textContent.trim();
        }
      }
      
      return '';
    },
    
    getProductHandle: function() {
      const pathname = window.location.pathname;
      const match = pathname.match(/\/products\/([^\/]+)/);
      return match ? match[1] : '';
    },
    
    formatPrice: function(price) {
      if (!price) return '';
      
      // Convert cents to dollars if needed
      if (typeof price === 'number') {
        return (price / 100).toFixed(2);
      }
      
      return price.toString();
    },
    
    saveProduct: function(productData) {
      // Validate product data before saving
      if (!productData || 
          !productData.title || 
          productData.title.trim() === '' ||
          productData.title === 'undefined' ||
          !productData.image || 
          productData.image.trim() === '' ||
          !productData.url ||
          productData.url.trim() === '') {
        console.warn('Recently Viewed Tracker: Invalid product data, not saving');
        return;
      }
      
      let recentlyViewed = this.getRecentlyViewed();
      
      // Remove if already exists (to avoid duplicates)
      recentlyViewed = recentlyViewed.filter(item => 
        item.handle !== productData.handle && item.id !== productData.id
      );
      
      // Add to beginning of array
      recentlyViewed.unshift(productData);
      
      // Limit to maximum number of products
      if (recentlyViewed.length > this.maxProducts) {
        recentlyViewed = recentlyViewed.slice(0, this.maxProducts);
      }
      
      // Save to localStorage
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(recentlyViewed));
      } catch (error) {
        console.warn('Recently Viewed Tracker: Error saving to localStorage', error);
      }
    },
    
    getRecentlyViewed: function() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        const products = stored ? JSON.parse(stored) : [];
        
        // Filter out any invalid products that might have been stored
        return products.filter(product => 
          product && 
          product.title && 
          product.title.trim() !== '' &&
          product.title !== 'undefined' &&
          product.image && 
          product.image.trim() !== '' &&
          product.url &&
          product.url.trim() !== ''
        );
      } catch (error) {
        console.warn('Recently Viewed Tracker: Error reading from localStorage', error);
        return [];
      }
    },
    
    // Public methods for managing recently viewed products
    clearRecentlyViewed: function() {
      try {
        localStorage.removeItem(this.storageKey);
      } catch (error) {
        console.warn('Recently Viewed Tracker: Error clearing localStorage', error);
      }
    },
    
    getRecentlyViewedProducts: function() {
      return this.getRecentlyViewed();
    },
    
    removeProduct: function(productId) {
      let recentlyViewed = this.getRecentlyViewed();
      recentlyViewed = recentlyViewed.filter(item => item.id !== productId);
      
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(recentlyViewed));
      } catch (error) {
        console.warn('Recently Viewed Tracker: Error updating localStorage', error);
      }
    }
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      RecentlyViewedTracker.init();
    });
  } else {
    RecentlyViewedTracker.init();
  }
  
  // Make it globally accessible for debugging
  window.RecentlyViewedTracker = RecentlyViewedTracker;
  
})();